import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Url } from "../../config/config";
import { isLoggedIn } from "../../utils";
import useButtonLoader from "../../hooks/useButtonLoader";
import { Instance, setToken } from "../../config/Instance";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { usePlacesWidget } from "react-google-autocomplete";

const UpdateUser = () => {
  const { id } = useParams();

  //************************ Handle all state for Form data ****************************//
  // State for getting state list form API
  const [natureBusinessList, setNatureBusinessList] = useState([]);

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // state for update Address Using Google Api
  const [addrs, setAddrs] = useState("");

  // State for FormData
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    contactNum: "",
    address: "",
    nameOfBusiness: "",
    avgMonBill: "",
    AvgProfitlastFiveYear: "",
    natureOfTheBusiness: "",
    companyPan: "",
    totalroofArea: "",
  });

  // State for Showing Error for Form Data
  const [errorField, setErrorField] = useState({
    firstName: "",
    lastName: "",
    contactNum: "",
    address: "",
    nameOfBusiness: "",
    avgMonBill: "",
    AvgProfitlastFiveYear: "",
    natureOfTheBusiness: "",
    companyPan: "",
    totalroofArea: "",
  });

  //************** Destructuring Variables for handle Form Validation *********************//
  const {
    firstName,
    lastName,
    contactNum,
    address,
    nameOfBusiness,
    avgMonBill,
    AvgProfitlastFiveYear,
    natureOfTheBusiness,
    companyPan,
    totalroofArea,
  } = formData;

  // ******************* Custom Hook for Submit button ***************************//
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  const navigate = useNavigate();

  //*************** Function for getting State list form API ****************************//
  const handelNatureOfBusiness = async () => {
    try {
      const { data } = await Instance.get(`/web/natureListing`, setToken());
      if (data.status === 200) {
        setNatureBusinessList(data.data.natureList);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //  function for handle Location field form
  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyBhze-SRpD3JWAqiwLe7AFapHTduVmwZG8",
    onPlaceSelected: (place) => {
      setAddrs(place?.formatted_address);
    },
    options: {
      types: [],
    },
  });

  //************************ Handel OnChange ***************************** */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "companyPan") {
      setFormData({ ...formData, [name]: value.toUpperCase() });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!firstName) {
      errorField["firstName"] = "Please enter first name";
      formIsValid = false;
    }

    if (!lastName) {
      errorField["lastName"] = "Please enter last name";
      formIsValid = false;
    }

    if (!contactNum) {
      errorField["contactNum"] = "Please enter contact number";
      formIsValid = false;
    }

    if (contactNum.length < 10) {
      errorField["contactNum"] = "Please enter valid contact number";
      formIsValid = false;
    }

    if (!nameOfBusiness) {
      errorField["nameOfBusiness"] = "Please enter name of business";
      formIsValid = false;
    }

    if (!avgMonBill) {
      errorField["avgMonBill"] =
        "Please enter average monthly electricity bill";
      formIsValid = false;
    }

    if (!address) {
      errorField["address"] = "Please enter address";
      formIsValid = false;
    }

    if (!AvgProfitlastFiveYear) {
      errorField["AvgProfitlastFiveYear"] =
        "Please select average annual profit";
      formIsValid = false;
    }

    if (!natureOfTheBusiness) {
      errorField["natureOfTheBusiness"] = "Please select nature of business";
      formIsValid = false;
    }

    if (!companyPan) {
      errorField["companyPan"] = "Please enter company pan number";
      formIsValid = false;
    }

    if (!totalroofArea) {
      errorField["totalroofArea"] = "Please enter plot size ";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };

  //********************* Handle Getting Details of User for Edit  *********************//
  const getDetails = async () => {
    try {
      showLoader();
      const token = isLoggedIn().token;
      const res = await axios({
        url: `${Url}/single_user_details/${id}`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      if (res.data.status === 200) {
        setFormData(res.data.data.user);
        setAddrs(res.data.data.user.address);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //******************** Handle OnSubmit function for Submit Form data ********************//
  const handelSubmit = async (e) => {
    e.preventDefault();
    try {
      if (handleValidation()) {
        setSubmitLoading(true);
        const token = isLoggedIn().token;
        const { data } = await axios({
          url: `${Url}/update_user`,
          method: "PUT",
          data: {
            id: id,
            firstName: formData.firstName,
            lastName: formData.lastName,
            contactNum: formData.contactNum,
            address: addrs,
            nameOfBusiness: formData.nameOfBusiness,
            avgMonBill: formData.avgMonBill,
            AvgProfitlastFiveYear: formData.AvgProfitlastFiveYear,
            natureOfTheBusiness: formData.natureOfTheBusiness,
            companyPan: formData.companyPan,
            totalroofArea: formData.totalroofArea,
          },
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        if (data.status === 200) {
          toast.success(data.message);
          setSubmitLoading(false);
          navigate("/user");
        } else {
          toast.error(data.message);
          setSubmitLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect it run only once at the time of getting details of State form API
  useEffect(() => {
    handelNatureOfBusiness();
    getDetails();
  }, []);

  //********************************* Start HTML PART(JSX PART)  *******************//
  return (
    <React.Fragment>
      <title>Edit User</title>
      <div className="WrapperArea _add_partner">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              {" "}
              <Link to="/user" className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              Edit User
            </h4>
            {loader}
            {/* <form method="POST" className='my-5'> */}
            <div className="PasswordArea">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      value={firstName}
                      onChange={handleInputChange}
                      name="firstName"
                      className="form-control"
                      placeholder="First Name"
                      maxLength="30"
                      onKeyPress={(event) => {
                        if (!/[a-z A-Z]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.firstName}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Name of the Business</label>
                    <input
                      type="text"
                      value={nameOfBusiness}
                      onChange={handleInputChange}
                      name="nameOfBusiness"
                      className="form-control"
                      placeholder="Name of the Business"
                      onKeyPress={(event) => {
                        if (!/[a-z A-Z]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.nameOfBusiness}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Average Monthly Electricity Bill</label>
                    <input
                      type="text"
                      value={avgMonBill}
                      onChange={handleInputChange}
                      name="avgMonBill"
                      className="form-control"
                      placeholder="Average Monthly Electricity Bill"
                      maxLength="60"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.avgMonBill}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      value={contactNum}
                      onChange={handleInputChange}
                      name="contactNum"
                      className="form-control"
                      placeholder="Contact Number"
                      maxLength="10"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.contactNum}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Plot size of your Facility</label>
                    <input
                      type="text"
                      value={totalroofArea}
                      onChange={handleInputChange}
                      name="totalroofArea"
                      className="form-control"
                      placeholder="Plot size of your facility(sqf.)"
                      maxLength="70"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.totalroofArea}
                    </span>
                  </div>
                </div>

                {/* Add 2 col-sm-6 */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      value={lastName}
                      onChange={handleInputChange}
                      name="lastName"
                      className="form-control"
                      placeholder="Last Name"
                      maxLength="30"
                      onKeyPress={(event) => {
                        if (!/[a-z A-Z]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.lastName}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Nature of Business</label>
                    <select
                      className="form-control"
                      name="natureOfTheBusiness"
                      value={natureOfTheBusiness}
                      onChange={handleInputChange}
                    >
                      <option>Nature of Business</option>
                      {natureBusinessList &&
                        natureBusinessList.map((item, i) => {
                          return (
                            <option key={i} value={item.financialPartnerName}>
                              {item.financialPartnerName}
                            </option>
                          );
                        })}
                    </select>
                    <span style={{ color: "red" }} className="error">
                      {errorField.natureOfTheBusiness}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Average Annual Profit</label>
                    <select
                      className="form-control"
                      name="AvgProfitlastFiveYear"
                      value={AvgProfitlastFiveYear}
                      onChange={handleInputChange}
                    >
                      <option value="">Average Annual Profit</option>
                      <option value="750000">0 - 15 Lakh</option>
                      <option value="3250000">15 - 50 Lakh</option>
                      <option value="7500000">50 - 100 Lakh</option>
                      <option value="15000000">Above 100 Lakh</option>
                    </select>
                    <span style={{ color: "red" }} className="error">
                      {errorField.AvgProfitlastFiveYear}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Company Pan Number </label>
                    <input
                      type="text"
                      value={companyPan}
                      onChange={handleInputChange}
                      name="companyPan"
                      className="form-control"
                      placeholder="Company Pan Number"
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.companyPan}
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Address of the Business</label>
                    <input
                      ref={ref}
                      type="text"
                      defaultValue={addrs}
                      name="address"
                      className="form-control"
                      placeholder="Address of the Business"
                    />
                    <span style={{ color: "red" }} className="error">
                      {errorField.address}
                    </span>
                  </div>
                </div>
                <div className="button_wrap">
                  <button
                    className="button"
                    onClick={handelSubmit}
                    ref={submitButtonElement}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            {/* </form> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UpdateUser;
